"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileStreamFromBuffer = void 0;
const stream_1 = require("stream");
function getFileStreamFromBuffer(file) {
    const fileStream = new stream_1.Readable();
    fileStream.push(file);
    fileStream.push(null);
    return fileStream;
}
exports.getFileStreamFromBuffer = getFileStreamFromBuffer;
//# sourceMappingURL=file.js.map